import { buildFeaturePageLandingPath } from "./buildFeaturePageLandingPath";
import type { FEATURE_PAGE_PATHS, FeaturePageFamily } from "./featurePagePaths";
import type { ViewerLocale } from "./viewerPreferences";

export function buildFeaturePagePath<F extends FeaturePageFamily>(
  locale: ViewerLocale,
  family: F,
  slug: string,
): `/${ViewerLocale}${(typeof FEATURE_PAGE_PATHS)[F]}/${string}` {
  return `${buildFeaturePageLandingPath(locale, family)}/${slug}`;
}
